export default function () {
  this.loadCategories()
  if (this.$route.params.id) {
    this.loadItem()
  }
}
